import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props} viewBox={'0 0 512 512'}>
        <path        stroke={"#F72585"}
                     fill={"#F72585"}d="M288 264c0-31-25-56-56-56s-56 25-56 56 25 56 56 56c13 0 24-4 33-11l57 57 12-12-57-57c7-9 11-20 11-33zm-96 0c0-22 18-40 40-40s40 18 40 40-18 40-40 40-40-18-40-40zM326 32h-30V0h-80v32h-30l-6 24H72v456h368V56H332zM198 48h34V16h48v32h34l12 48H186zm226 24v424H88V72h88l-10 40h180l-10-40z" />
    </svg>
)

export default SvgComponent
